import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Spinner, Alert } from "react-bootstrap";

import ProductSearch from "./ProductSearch";
import ProductList from "./ProductList";
import ProductGroupList from "./ProductGroupList";

import "./ProductSelectionPanel.css";
import { searchProducts4Invoice, searchProducts4InvoiceAsync } from "../../../../store/api/GetAllProduct";

const ProductSelectionPanel = ({
    productGroups = [],
    searchProducts,
    onProductSelect,
    initialGroupId = null,
    initialSearchType = "nameModel",
    debounceDelay = 300
}) => {
    const [selectedGroupId, setSelectedGroupId] = useState(initialGroupId);
    const [searchType, setSearchType] = useState(initialSearchType);
    const [searchText, setSearchText] = useState("");

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const requestIdRef = useRef(0);

    const executeSearch = async () => {
        if (typeof searchProducts !== "function") {
            setError("تابع جستجوی محصولات مشخص نشده است.");
            return;
        }

        const requestId = ++requestIdRef.current;

        setLoading(true);
        setError(null);

        try {
            const result = await searchProducts4InvoiceAsync({
                GroupID: selectedGroupId,
                searchType,
                searchText: searchText.trim()
            });

            // جلوگیری از اینکه پاسخ درخواست قدیمی
            // نتیجه درخواست جدید را overwrite کند.
            if (requestId !== requestIdRef.current) {
                return;
            }

            const resultProducts = Array.isArray(result)
                ? result
                : result?.products;

            setProducts(Array.isArray(resultProducts) ? resultProducts : []);
        } catch (err) {
            if (requestId !== requestIdRef.current) {
                return;
            }

            console.error("Product search error:", err);

            setProducts([]);
            setError("خطا در دریافت محصولات");
        } finally {
            if (requestId === requestIdRef.current) {
                setLoading(false);
            }
        }
    };


    const handleGroupSelect = (groupId) => {
        setSelectedGroupId(groupId);
    };

    const handleSearchTypeChange = (value) => {
        setSearchType(value);
    };

    const handleSearchTextChange = (value) => {
        setSearchText(value);
    };

    const handleProductSelect = (product, quantity) => {
        if (typeof onProductSelect === "function") {
            onProductSelect(product, quantity);
        }
    };
    useEffect(() => {
        const timer = setTimeout(() => {
            executeSearch();
        }, debounceDelay);

        return () => {
            clearTimeout(timer);
        };
    }, [searchText]);    
    useEffect(() => {
        if (selectedGroupId != null) {
            executeSearch();
        }
    }, [selectedGroupId]);

    return (
        <div
            className="product-selection-panel"
            dir="rtl"
        >
            <div className="product-selection-search">
                <ProductSearch
                    searchType={searchType}
                    searchText={searchText}
                    onSearchTypeChange={handleSearchTypeChange}
                    onSearchTextChange={handleSearchTextChange}
                />
            </div>

            <Row className="product-selection-row no-gutters">

                {/* 
                    در RTL، Group ابتدا قرار گرفته تا از نظر بصری
                    در سمت راست نمایش داده شود.
                */}
                <Col
                    xs={12}
                    md={2}
                    className="product-groups-column"
                >
                    <ProductGroupList
                        groups={productGroups}
                        selectedGroupId={selectedGroupId}
                        onGroupSelect={handleGroupSelect}
                    />
                </Col>

                <Col
                    xs={12}
                    md={10}
                    className="product-list-column"
                >
                    <div className="product-list-container">

                        {loading && (
                            <div className="product-selection-loading">
                                <Spinner
                                    animation="border"
                                    role="status"
                                >
                                    <span className="sr-only">
                                        در حال دریافت اطلاعات...
                                    </span>
                                </Spinner>

                                <span className="loading-text">
                                    در حال دریافت محصولات...
                                </span>
                            </div>
                        )}

                        {!loading && error && (
                            <Alert
                                variant="danger"
                                className="product-selection-alert"
                            >
                                {error}
                            </Alert>
                        )}

                        {!loading && !error && (
                            <ProductList
                                products={products}
                                onProductSelect={handleProductSelect}
                            />
                        )}

                    </div>
                </Col>

            </Row>
        </div>
    );
};

export default ProductSelectionPanel;
